import React from 'react'

import { Field } from 'formik'

import { Form, Col, Row, Button } from '_zari/core'

import { TiposDocumentoSerieConstant, TiposDocumentoSunatConstant } from 'constants/index'

import * as UsuarioService from 'services/usuario.service'

import * as Modals from './modals'

const SerieNumeroFormGroup = ({
  fIsSubmitting,
  flagEditar,
  flagNuevaNota,
  vTipoDocumento,
  setFieldValue,
  flagEditarComentarios,
  vSerieReferencia,
  flagSerieContingencia,
  mostrarSeriesModal
}) => {
  const [mostrarTablaSeriesModal, setMostrarTablaSeriesModal] = React.useState(false)
  const [series, setSeries] = React.useState([])

  React.useEffect(() => {
    if (!flagSerieContingencia) {
      if (!flagEditar) {
        setFieldValue('serieDocumento', '')
        setSeries([])
      }

      if (vTipoDocumento) {
        let tipoSerie = ''
        if (vTipoDocumento === TiposDocumentoSunatConstant.BOLETA) {
          tipoSerie = TiposDocumentoSerieConstant.VENTAS_BOLETA
        } else if (vTipoDocumento === TiposDocumentoSunatConstant.FACTURA) {
          tipoSerie = TiposDocumentoSerieConstant.VENTAS_FACTURA
        } else if (vTipoDocumento === TiposDocumentoSunatConstant.NOTA_CREDITO) {
          if (flagNuevaNota) {
            if (vSerieReferencia.startsWith('F')) {
              tipoSerie = TiposDocumentoSerieConstant.VENTAS_NOTACREDITO_FACTURA
            } else {
              tipoSerie = TiposDocumentoSerieConstant.VENTAS_NOTACREDITO_BOLETA
            }
          } else {
            tipoSerie = 'NotaAnioAnterior'
          }
        } else if (vTipoDocumento === TiposDocumentoSunatConstant.OTROS) {
          tipoSerie = TiposDocumentoSerieConstant.VENTAS_TICKET
        }

        UsuarioService.self.obtenerSeriesxTipoSerie({ tipoSerie: tipoSerie }).then(({ data }) => {
          if (data && data.length > 0) {
            setSeries(data)
            if (!flagEditar) {
              setFieldValue('serieDocumento', data[0])
              setFieldValue('tipoSerie', tipoSerie)
            }
          }
        })
      }
    }
  }, [vSerieReferencia, vTipoDocumento, setFieldValue, flagEditar, flagSerieContingencia, flagNuevaNota])

  return (
    <>
      <Form.Group>
        <Form.Label text='SERIE' htmlFor='select-serie' md={4} alignRightAt='md' />
        <Col md={8}>
          <Row>
            <Col xs={5} sm={6} md={12}>
              <Form.InputGroup>
                {flagSerieContingencia ? (
                  <Field name='serieDocumento'>
                    {({ field }) => (
                      <Form.InputText
                        {...field}
                        id='input-serieDocumento'
                        disabled={fIsSubmitting || flagEditarComentarios}
                      />
                    )}
                  </Field>
                ) : (
                  <Field name='serieDocumento'>
                    {({ field }) => (
                      <Form.Select
                        {...field}
                        disabled={fIsSubmitting || flagEditarComentarios || flagEditar}
                        id='select-serie'
                      >
                        {series.map(x => (
                          <option key={x} value={x}>
                            {x}
                          </option>
                        ))}
                      </Form.Select>
                    )}
                  </Field>
                )}
                <Form.InputGroup.Append>
                  <Button onClick={() => setMostrarTablaSeriesModal(true)}>o</Button>
                </Form.InputGroup.Append>
              </Form.InputGroup>
            </Col>
            {flagEditar || flagSerieContingencia ? (
              <Col xs={7} sm={6} md={12}>
                <Form.InputGroup>
                  <Field name='numeroDocumento'>
                    {({ field }) => (
                      <Form.InputText
                        {...field}
                        id='input-numeroDocumento'
                        disabled={!flagSerieContingencia || fIsSubmitting}
                        style={{
                          padding: '.5rem .6rem'
                        }}
                      />
                    )}
                  </Field>
                </Form.InputGroup>
              </Col>
            ) : null}
          </Row>
        </Col>
      </Form.Group>

      <Form.Group>
        <Col md={4} />
        <Col md={8}>
          <Field name='flagSerieContingencia'>
            {({ field }) => (
              <Form.Checkbox
                {...field}
                checked={flagSerieContingencia}
                disabled={fIsSubmitting}
                id='checkbox-flagSerieContingencia'
                label='Serie contingencia'
              />
            )}
          </Field>
        </Col>
      </Form.Group>
      {mostrarTablaSeriesModal && (
        <Modals.TablaSeriesModal show={mostrarTablaSeriesModal} handleClose={() => setMostrarTablaSeriesModal(false)} />
      )}
    </>
  )
}

export default React.memo(SerieNumeroFormGroup)
